import dayjs from 'dayjs';
import { IPromotion, PromotionTemplate } from '@/models/promotion.model';
import { CouponFormFields } from './types';

export const getEditCouponInitialValues = (coupon: IPromotion | null) => ({
  [CouponFormFields.CODE]: coupon?.code,
  [CouponFormFields.DATE_FROM]: coupon?.dateFrom ? dayjs(coupon?.dateFrom) : undefined,
  [CouponFormFields.DATE_TO]: coupon?.dateTo ? dayjs(coupon?.dateTo) : undefined,
  [CouponFormFields.RATE]: coupon?.rate || undefined,
  [CouponFormFields.MIN_ORDER_AMOUNT]: coupon?.minOrderAmount || undefined,
  [CouponFormFields.POPUP_TITLE]: coupon?.name,
  [CouponFormFields.POPUP_DESCRIPTION]: coupon?.description,
  [CouponFormFields.TEMPLATE]: coupon?.templateNumber || PromotionTemplate.DARK,
});
